import { defineStore } from 'pinia';
import { MyBets } from './MyBets';

export const useHistoryStore = defineStore('history', {
	state: () => ({
		deposits: {},
		withdrawals: {},
		unsettled_bets: {
			data: [],
		},
		slots: {},
		live_casino: {},
		settled_bets: {},
		transactions: {},
		transactions_filters: {
			from: null,
			to: null,
			types: {
				bets: false,
				withdrawals: false,
				deposits: false,
				casino: false,
				live_casino: false,
				bonus: false
			},
		},
		history_loading: false,
		betslip_details: {
			data: null,
			loading: false,
			error: null,
		},
	}),
	getters: {
		getDeposits(state){
			return state.deposits
		},
		getWithdrawals(state){
			return state.withdrawals
		},
		getUnsettledBets(state){
			const myBetsStore = MyBets();
			state.unsettled_bets.data.forEach((betslip) => {
				if (betslip.freebet_id == null && betslip.bonus_can_cashout) {
					betslip.cashout_amount = myBetsStore.betslipCashout(betslip);
					betslip.cashout_available = true;
					if (betslip.cashout_amount == null || betslip.cashout_amount == 0) {
						betslip.cashout_available = false;
					}
				}

			});

			return state.unsettled_bets
		},
		getSettledBets(state){
			return state.settled_bets
		},
		getSlots(state){
			return state.slots
		},
		getLiveCasino(state){
			return state.live_casino
		},
		getTransactions(state){
			return state.transactions
		},
		getBetslipDetails(state) {
			return state.betslip_details
		},

	},
	actions: {
		fetchDepositHistory(payload){
			this.history_loading = true

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/history/transactions/deposits?page=' + payload.page, {from: payload.from, to: payload.to}).then((response) => {
				this.deposits = response.data
				this.history_loading = false
			}).catch((error) => {
				this.history_loading = false
				return Promise.reject(error.response);
			});
		},
		fetchWithdrawalHistory(payload){
			this.history_loading = true

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/history/transactions/withdrawals?page=' + payload.page, {from: payload.from, to: payload.to}).then((response) => {
				this.withdrawals = response.data
				this.history_loading = false
			}).catch((error) => {
				this.history_loading = false
				return Promise.reject(error.response);
			});
		},
		fetchUnsettledBetsHistory(payload){
			this.history_loading = true

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/history/betslips/unsettled?page=' + payload.page, {from: payload.from, to: payload.to}).then((response) => {
				this.unsettled_bets = response.data
				this.history_loading = false
			}).catch((error) => {
				this.history_loading = false
				return Promise.reject(error.response);
			});
		},
		fetchSlotsHistory(payload){
			this.history_loading = true

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/history/casino/slots?page=' + payload.page, {from: payload.from, to: payload.to, filter_by: payload.filter_by, game_type: 'slots'}).then((response) => {
				this.slots = response.data
				this.history_loading = false
			}).catch((error) => {
				this.history_loading = false
				return Promise.reject(error.response);
			});
		},
		fetchLiveCasinoHistory(payload){
			this.history_loading = true

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/history/casino/slots?page=' + payload.page, {from: payload.from, to: payload.to, filter_by: payload.filter_by, game_type: 'live_casino'}).then((response) => {
				this.live_casino = response.data
				this.history_loading = false
			}).catch((error) => {
				this.history_loading = false
				return Promise.reject(error.response);
			});
		},
		fetchSettledBetsHistory(payload){
			this.history_loading = true

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/history/betslips/settled?page=' + payload.page, {from: payload.from, to: payload.to}).then((response) => {
				this.settled_bets = response.data
				this.history_loading = false
			}).catch((error) => {
				this.history_loading = false
				return Promise.reject(error.response);
			});
		},
		fetchTransactionHistory(payload){
			this.history_loading = true

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/history/transactions/overall?page=' + payload.page, {from: this.transactions_filters.from, to: this.transactions_filters.to, types: this.transactions_filters.types}).then((response) => {
				this.transactions = response.data

				this.history_loading = false
				return Promise.resolve(response)
			}).catch((error) => {
				this.history_loading = false
				return Promise.reject(error.response);
			});
		},
		fetchBetslipDetails(betslip_id) {
			this.betslip_details.loading = true
			this.betslip_details.error = null
			return global.axios.get(process.env.VUE_APP_API_URL + '/account/history/betslips/' + betslip_id).then((response) => {
				this.betslip_details.data = response.data.data
				this.betslip_details.loading = false
			return Promise.resolve(response)
		}).catch((error) => {
				this.betslip_details.loading = false
				this.betslip_details.error = error.response
				return Promise.reject(error.response)
			});
		},
		clearTransactionsFilters() {
			// this.transactions_filters.from = null
			// this.transactions_filters.to = null
			this.transactions_filters.types.bets = false
			this.transactions_filters.types.withdrawals = false
			this.transactions_filters.types.deposits = false
			this.transactions_filters.types.casino = false
			this.transactions_filters.types.live_casino = false
			this.transactions_filters.types.bonus = false
		}
	},
	persist: {
		storage: localStorage,
		paths: ['transactions_filters'],
	},
})